export default __webpack_public_path__ + "static/media/book.036c64b8.svg";